"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useForm = exports.Form = exports.SubmitButton = void 0;
var tslib_1 = require("tslib");
var Form_1 = require("@reactionable/core/lib/form/Form");
var formik_1 = require("formik");
var react_1 = tslib_1.__importStar(require("react"));
var Button_1 = tslib_1.__importDefault(require("react-bootstrap/Button"));
var react_i18next_1 = require("react-i18next");
function SubmitButton(_a) {
    var children = _a.children, props = tslib_1.__rest(_a, ["children"]);
    var t = react_i18next_1.useTranslation().t;
    return (react_1.default.createElement(Button_1.default, tslib_1.__assign({ type: "submit", variant: "primary", children: react_1.Children.count(children) ? children : t('Save') }, props)));
}
exports.SubmitButton = SubmitButton;
function Form(_a) {
    var children = _a.children, submitButton = _a.submitButton, props = tslib_1.__rest(_a, ["children", "submitButton"]);
    var renderChildren = function (formikProps) {
        return (react_1.default.createElement(formik_1.Form, { className: "needs-validation mb-1" },
            children(formikProps),
            submitButton && (react_1.default.createElement(SubmitButton, tslib_1.__assign({}, {
                disabled: formikProps.isSubmitting,
                children: typeof submitButton === 'string' ? submitButton : undefined,
            })))));
    };
    return react_1.default.createElement(Form_1.Form, tslib_1.__assign({}, props, { children: renderChildren }));
}
exports.Form = Form;
function useForm(props) {
    return Form_1.useForm(tslib_1.__assign({ Component: Form }, props));
}
exports.useForm = useForm;
//# sourceMappingURL=Form.js.map